var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"common-checkout",on:{"click":_vm.handClick}},[_c('svg-icon',{attrs:{"iconClass":_vm.value?'selected':'selectbox',"className":"icon-16 gray-cl selectbox-icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }